function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-485.000000, -277.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(485.000000, 277.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "to-fill",
  id: "Rectangle",
  fill: "#220BAB",
  x: 0,
  y: 0,
  width: 470,
  height: 470,
  rx: 20
}), /*#__PURE__*/React.createElement("text", {
  className: "to-color",
  id: "A-summary-of-John-Do",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 64,
  fontWeight: "bold",
  "line-spacing": 70,
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 61,
  y: 160
}, "A summary"), /*#__PURE__*/React.createElement("tspan", {
  x: 61,
  y: 230
}, "of John"), /*#__PURE__*/React.createElement("tspan", {
  x: 61,
  y: 300
}, "Doe\u2026")), /*#__PURE__*/React.createElement("text", {
  className: "to-color",
  id: "\\uD83D\\uDCCD-San-Francisco,-US",
  fontFamily: "AppleColorEmoji, Apple Color Emoji",
  fontSize: 32,
  fontWeight: "normal",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 61,
  y: 363
}, "\uD83D\uDCCD"), /*#__PURE__*/React.createElement("tspan", {
  x: 93,
  y: 363,
  fontFamily: "AvenirNext-DemiBold, Avenir Next",
  fontWeight: 500
}, " San Francisco, US")), /*#__PURE__*/React.createElement("text", {
  className: "to-color",
  id: "More-about-me",
  fontFamily: "AvenirNext-Medium, Avenir Next",
  fontSize: 18,
  fontWeight: 400,
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 273,
  y: 440
}, "More about me")), /*#__PURE__*/React.createElement("g", {
  className: "to-color",
  id: "arrow-right",
  transform: "translate(421.000000, 428.000000)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,8 L16,8",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "8 0 16 8 8 16"
})))));

var SvgBasics = function SvgBasics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basics.ccb33acd.svg";
export { ForwardRef as ReactComponent };